import { Fragment, useEffect } from "react"

import { marketingClient, orderClient, useQuery } from "@trueskin-web/apis"
import { Seo } from "@trueskin-web/components"
import { Routes, useTranslation } from "@trueskin-web/translations"

import PaymentLayout from "./payment"

const Payment = () => {
  const { t } = useTranslation()

  useQuery("currentOrderSummary", orderClient.getCurrentSummary)

  useEffect(() => {
    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.CART_SUMMARY_PAGE,
    })
  }, [])

  return (
    <Fragment>
      <Seo title={t("Start.Payment.seoTitle")} />

      <PaymentLayout
        backUrl={Routes.App.Start.Shipping.url}
        title={t("Plans.DesktopSidebarWrapper.title")}
        description={t("Plans.DesktopSidebarWrapper.description")}
        data-component-name="StartPayment"
      />
    </Fragment>
  )
}

export default Payment
